import React from "react";

/**
 * CompassLogo — an animated SVG mark used on onboarding and empty states.
 * Solid, minimal, brand-forward. Not a Lucide icon: we need the extra polish.
 */
export function CompassLogo({ size = 128, className = "" }) {
  const s = size;
  return (
    <div
      className={`relative ${className}`}
      style={{ width: s, height: s }}
      aria-hidden="true"
      data-testid="compass-logo"
    >
      {/* Soft glow */}
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(244,201,93,0.28) 0%, rgba(244,201,93,0) 65%)",
          filter: "blur(6px)",
        }}
      />
      <svg
        viewBox="0 0 128 128"
        width={s}
        height={s}
        className="dc-drift relative"
      >
        {/* Outer ring */}
        <circle
          cx="64"
          cy="64"
          r="56"
          fill="none"
          stroke="rgba(255,255,255,0.14)"
          strokeWidth="1"
        />
        <circle
          cx="64"
          cy="64"
          r="46"
          fill="none"
          stroke="rgba(232,216,184,0.35)"
          strokeWidth="0.75"
          strokeDasharray="2 4"
        />

        {/* Cardinal ticks */}
        {[0, 90, 180, 270].map((deg) => (
          <line
            key={deg}
            x1="64"
            y1="10"
            x2="64"
            y2="18"
            stroke="rgba(232,216,184,0.6)"
            strokeWidth="1.2"
            transform={`rotate(${deg} 64 64)`}
          />
        ))}

        {/* Compass needle (north = gold) */}
        <g transform="rotate(-18 64 64)">
          <polygon points="64,20 60,64 68,64" fill="#F4C95D" />
          <polygon
            points="64,108 60,64 68,64"
            fill="rgba(232,216,184,0.55)"
          />
          <circle cx="64" cy="64" r="4" fill="#0F172A" stroke="#F4C95D" strokeWidth="1.5" />
        </g>

        {/* Small star for a hint of dawn */}
        <circle cx="102" cy="30" r="1.6" fill="#E8D8B8" />
        <circle cx="24" cy="42" r="1.1" fill="#A78BFA" />
        <circle cx="34" cy="96" r="1.3" fill="#E8D8B8" />
      </svg>
    </div>
  );
}
